import React from "react";
import { useParams } from 'react-router-dom';
import { Drawer, Group, Text, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import { utils } from "../../utils/globalVariables";

import DeliveryJemputNotaBasicData from "./DeliveryJemputNotaBasicData";

const DeliveryJemputNotaAdd = ({
    fnCloseDrawer,
    fnRefreshIndex,
    fnSuccessBatal
}) => {

    const { URI1 } = useParams();

    const utilsRef = React.useRef({
        currentStep: utils.penjemputanSteps.nota.value,
        isCancel: '0',
        userAccess: [
            // role.owner.subLevel.owner.slugSubLevel,
            // role.admin.subLevel.admin_kepala.slugSubLevel,
            // role.admin.subLevel.admin_staf.slugSubLevel,
        ]
    })

    return (
        <React.Fragment>
            <Drawer
                opened={URI1}
                onClose={fnCloseDrawer}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnCloseDrawer}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Tambah Penjemputan</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <DeliveryJemputNotaBasicData
                    stateData={{
                        showSubmitComponent: true,
                        utilsRef: utilsRef.current,
                    }}

                    fnRefreshIndex={fnRefreshIndex}
                    fnCloseDrawer={fnCloseDrawer}
                    fnSuccessSubmit={fnRefreshIndex}
                    fnSuccessBatal={fnSuccessBatal}
                />
            </Drawer>
        </React.Fragment>
    )
}

export default React.memo(DeliveryJemputNotaAdd);